import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import reducer from '../reducers';
import { getSession } from '../lib/crossover';

export default function createPivotStore() {
  const enhancer = createEnhancer(thunk);
  const state = { login: getSession() };
  const store = createStore(reducer, state, enhancer);

  return store;
}

function createEnhancer(...middlewares) {
  const enhancer = applyMiddleware(...middlewares);
  // FIXME: uncomment, when we go to production
  // if (config.isProduction) return enhancer;

  const devTools = window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : f => f;

  return compose(
    enhancer,
    devTools,
  );
}
